/* eslint-disable react/display-name */
import React, { useState, useEffect, cloneElement } from "react"
import uuid4 from "uuid4";
import MetaTags from 'react-meta-tags';
import {
  Container,
  Modal,
  ModalBody,
  Form
} from "reactstrap"
import DatatableTables from "components/tables/DatatableTables";
import { EMPLOYEE, QR_CODE, DINER_STATUS, OPTIONS_URL } from 'helpers/url_helper'
import { post, get, del } from 'helpers/api_helper'
import Swal from 'sweetalert2';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
const formObj = {
  code: '',
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  location: '',
  canteen: '',
  is_mobile: "1",
  role: "R001",
}

const Employees = () => {
  const [loading, setLoading] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [submitBtnActive, setSubmitBtnActive] = useState(false);
  const [formData, setFormData] = useState(formObj);
  const [dinerData, setDinerData] = useState(null);
  const [options, setOptions] = useState(null);
  const [editData, setEditData] = useState(null);

  const handleDineStatus = async (row, type) => {
    toastr.options = {
      positionClass: "toast-top-right",
      timeOut: 5000,
      extendedTimeOut: 1000,
      closeButton: false,
      debug: false,
      progressBar: false,
      preventDuplicates: false,
      newestOnTop: true,
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
      showDuration: 300,
      hideDuration: 1000
    };
    let a = false;

    if(type === 'lunch'){
      setEmployeeData(prev => prev.map((item) => item.id === row.id ? { ...item, is_lunch: !item.is_lunch } : item));
      a = row.is_lunch ? false: true;
      if(a){
        toastr.success(`${row.firstname} ${row.lastname} allowed to get lunch`);
      }else{
        toastr.error(`${row.firstname} ${row.lastname} dismissed to get lunch`);
      }
    }
    if(type === 'dinner'){
      setEmployeeData(prev => prev.map((item) => item.id === row.id ? { ...item, is_diner: !item.is_diner } : item));
      a = row.is_diner ? false: true;
      if(a){
        toastr.success(`${row.firstname} ${row.lastname} allowed to get dinner`);
      }else{
        toastr.error(`${row.firstname} ${row.lastname} dismissed to get dinner`);
      }
    }
    if(type === 'item'){
      setEmployeeData(prev => prev.map((item) => item.id === row.id ? { ...item, rotla: !item.rotla } : item));
      a = row.rotla ? false: true;
      if(a){
        toastr.success(`${row.firstname} ${row.lastname} allowed to get Rotla`);
      }else{
        toastr.error(`${row.firstname} ${row.lastname} allowed to get Rotli`);
      }
    }
    if(type === 'is_manual'){
      setEmployeeData(prev => prev.map((item) => item.id === row.id ? { ...item, is_manual: !item.is_manual } : item));
      a = row.is_manual ? false: true;
      if(a){
        toastr.success(`${row.firstname} ${row.lastname} allowed to get Rotla`);
      }else{
        toastr.error(`${row.firstname} ${row.lastname} allowed to get Rotli`);
      }
    }

    const obj = {
      diner: row.code,
      type: type,
      status: a,
      is_guest: false
    }

    const res = await post(DINER_STATUS, obj);
  }

  const resetToken = async(code) => {
    setLoading(true)
    const res = await post(`${EMPLOYEE}/reset-token`, {code: code});
    if(res?.success) {
      setLoading(false);
    }
  }

  const columns = [{
    dataField: 'sr',
    text: '#',
    sort: true,
  },{
    dataField: 'firstname',
    text: 'Name',
    sort: true,
    formatter: (cell, row) => `${row.firstname} ${row.lastname}`
  },{
    dataField: 'code',
    text: 'Code',
    sort: true
  },{
    dataField: 'desk_id',
    text: 'Desk Number',
    sort: true
  },{
    dataField: 'actions2',
    text: 'Lunch',
    sort: true,
    formatter: (cell, row) => {
      return (
        <div className="form-check form-switch">
          <input type="checkbox" className="form-check-input"  id={`lunchbtn-${row.id}`} checked={row.is_lunch ? true: false} onChange={() => handleDineStatus(row, 'lunch')} />
        </div>
      );
    },
  },{
    dataField: 'actions3',
    text: 'Dinner',
    sort: true,
    formatter: (cell, row) => {
      return (
        <div className="form-check form-switch">
          <input type="checkbox" className="form-check-input" id={`dinerbtn-${row.id}`} checked={row.is_diner ? true: false}  onChange={() => handleDineStatus(row, 'dinner')} />
        </div>
      );
    },
  },{
    dataField: 'actions4',
    text: 'Rotla',
    sort: true,
    formatter: (cell, row) => {
      return (
        <div className="form-check form-switch">
          <input type="checkbox" className="form-check-input" id={`itembtn-${row.id}`} checked={row.rotla ? true: false}  onChange={() => handleDineStatus(row, 'item')} />
        </div>
      );
    },
  },{
    dataField: 'actions5',
    text: 'Allow Manual token',
    sort: true,
    formatter: (cell, row) => {
      return (
        <div className="form-check form-switch">
          <input type="checkbox" className="form-check-input" id={`is_manualbtn-${row.id}`} checked={row.is_manual ? true: false}  onChange={() => handleDineStatus(row, 'is_manual')} />
        </div>
      );
    },
  },{
    dataField: 'phone',
    text: 'Contact',
    sort: true
  },{
    dataField: 'actions',
    text: 'Actions',
    formatter: (cell, row) => {
      return (
        <>
          <button onClick={() => resetToken(row?.code)} className="btn btn-danger">
            <i className="fas fa-unlink" />
          </button> {" "}
          {/* <button onClick={() => modifyRecord(row)} className="btn btn-danger">
            Modify
          </button>
          {' '} */}
          <button onClick={() => setDinerData(row)} className="btn btn-success">
            <i className="fab fa-whatsapp"></i>{" "} Issue Token
          </button>  {" "}
          <button onClick={() => setEditData(row)} className="btn btn-warning">
            <i className="fas fa-edit"></i>{" "}
          </button>{" "}
          <button onClick={() => handleDeleteUser(row)} className={`btn btn-${row.status == 0? 'danger': 'success'}`}>
            <i className={`fas fa-${row.status == 0? 'trash': 'redo-alt'}`}></i>{" "}
          </button>
        </>
      );
    },
  }];

  const handleEditUser = async() => {
    setSubmitBtnActive(true);
    const obj = removeEmpty({ ...formData, code: editData?.code })
    const res = await post(EMPLOYEE, obj);
    if(res?.success){
      fetchData()
      setFormData(formObj)
      setEditData(null)
      setSubmitBtnActive(false);
      setModalOpen(false);
    }
  }

  const handleDeleteUser = async(data) => {
        Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      preConfirm: async () => {
        try {
          const res = await get(`${EMPLOYEE}/delete/${data?.id}`);
          if (res.body === 1) {
            Swal.fire(
              'Deleted!',
              'employee has been deleted.',
              'success'
            );
          } else {
            throw new Error('Delete failed');
          }
        } catch (error) {
          Swal.fire(
            'Error!',
            'There was a problem deleting employee.',
            'error'
          );
        }
      }
    });
  }

  const issueToken = async(_number) => {
    const obj = {
      "diner": dinerData?.code,
      "_number": _number,
      "is_guest": 0
    }
    const res = await post(`${QR_CODE}`, obj);
    if(res?.success) {
      setDinerData(null)
    }
  }

  const fetchData = async () => {
    setLoading(true);
    const res = await get(`${EMPLOYEE}`);
    if(res?.success) {
      const options = await get(`${OPTIONS_URL}`);
      setEmployeeData(res?.body)
      setLoading(false);
      setOptions(options?.body);
    }
  }

  useEffect(() => {
    fetchData();
  }, [])

  function removeEmpty(obj) {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, v]) => v != null && v !== '')
    );
  }

  const addRecord = async () => {
    setSubmitBtnActive(true);
    const res = await post(EMPLOYEE, formData);
    if(res.success){
      fetchData()
      setFormData(formObj)
      setSubmitBtnActive(false);
      setModalOpen(false);
    }
  }

  const editRecord = async (data) => {
    Swal.fire({
      title: "Currently Not Allowed!",
      text: "",
      icon: "warning"
    });
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Employees | Advance Dental Export Canteen Management</title>
        </MetaTags>
        <Container fluid>
          <DatatableTables isAdd={true} title={"Employees"} columns={columns} rows={employeeData} addBtnLabel={"Add Employee"} callback={() => setModalOpen(true)} />
          
          <Modal
            isOpen={modalOpen || editData != null}
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="modal-title">{`${editData != null ?  'Update':''} Employee`}</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => {
                setModalOpen(false);
                setEditData(null);
              }}><span aria-hidden="true">×</span></button>
            </div>
            <Form
              onSubmit={(v) => {
                v.preventDefault();
                if(editData != null){
                  handleEditUser()
                }else{
                  addRecord()
                }
              }}
            >
              <ModalBody>
                <div className="row mb-3">
                  <div className="col-12">
                    <label htmlFor="code" className="form-label imp">Employee Code</label>
                    <input name="code" id="code" placeholder="Enter employee code" required disabled={editData?.code} defaultValue={editData?.code || ''} type="text" onChange={(e) => setFormData(p => ({...p, code: e.target.value }))} className="form-control" />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-6">
                    <label htmlFor="firstname" className="form-label imp">First Name</label>
                    <input name="firstname" id="firstname" placeholder="Enter First name" required defaultValue={editData?.firstname || ''} type="text" onChange={(e) => setFormData(p => ({...p, firstname: e.target.value }))} className="form-control" />
                  </div>
                  <div className="col-6">
                    <label htmlFor="lastname" className="form-label imp">Last Name</label>
                    <input name="lastname" id="lastname" placeholder="Enter last name" required defaultValue={editData?.lastname || ''} type="text" onChange={(e) => setFormData(p => ({...p, lastname: e.target.value }))} className="form-control" />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-6">
                    <label htmlFor="email" className="form-label">Email Address</label>
                    <input name="email" id="email" placeholder="Enter First name" defaultValue={editData?.email || ''} onChange={(e) => setFormData(p => ({...p, email: e.target.value }))}  type="email" className="form-control" />
                  </div>
                  <div className="col-6">
                    <label htmlFor="phone" className="form-label imp">Contact Number</label>
                    <input name="phone" id="phone" placeholder="Enter Contact Number" defaultValue={editData?.phone || ''} type="text" onChange={(e) => setFormData(p => ({...p, phone: e.target.value }))} className="form-control" />
                  </div>
                </div>
                {
                  editData == null &&
                  <div className="row mb-3">
                    <div className="col-6">
                      <label htmlFor="location" className="form-label imp">Location</label>
                      {/* <input name="location" id="location" placeholder="Please Select Location" onChange={(e) => setFormData(p => ({...p, location: e.target.value }))} required type="text" className="form-control" /> */}
                      <select
                        id="dropdown"
                        className="form-control"
                        required
                        value={formData?.location}
                        onChange={(e) => setFormData(p => ({...p, location: e.target.value }))}
                        style={{ padding: "8px", borderRadius: "4px"}}
                      >
                        <option key='c1' value="">---</option>
                        {options?.locations?.map((option) => (
                          <option key={`${uuid4()}_${option.value}`} value={option.code}>
                            {option.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-6">
                      <label htmlFor="canteen" className="form-label imp">Canteen</label>
                      {/* <input name="canteen" id="canteen" placeholder="Please Select Canteen" onChange={(e) => setFormData(p => ({...p, canteen: e.target.value }))} required type="text" className="form-control" /> */}
                      <select
                        id="dropdown"
                        className="form-control"
                        required
                        value={formData?.canteen}
                        onChange={(e) => setFormData(p => ({...p, canteen: e.target.value }))}
                        style={{ padding: "8px", borderRadius: "4px"}}
                      >
                        <option key='c1' value="">---</option>
                        {options?.canteens?.map((option) => (
                          <option key={`${uuid4()}_${option.value}`} value={option.code}>
                            {option.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                }
              </ModalBody>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" onClick={() => {
                  setModalOpen(false);
                  setEditData(null);
                }}>Close</button>
                <button type="submit" className="btn btn-primary" disabled={submitBtnActive}>Submit</button>
              </div>
            </Form>
          </Modal>

          {/* Whastapp Numner */}
          <Modal
            isOpen={dinerData ? true: false}
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="modal-title">Issue Dine Token</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => setDinerData(null)}><span aria-hidden="true">×</span></button>
            </div>
            <Form
              onSubmit={(v) => {
                v.preventDefault();
                issueToken(v.target.wp_num.value)
              }}
            >
              <ModalBody>
                <div className="row mb-3">
                  <div className="col-12">
                    <label htmlFor="wp_num" className="form-label imp">Please Enter Mobile Number</label>
                    <input name="wp_num" id="wp_num" placeholder="Please Enter Mobile Number" required type="text" className="form-control" />
                  </div>
                  <div className="mt-2 col-12">
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td>Diner Name</td>
                          <td>{dinerData?.firstname} {dinerData?.lastname}</td>
                        </tr>
                        <tr>
                          <td>Diner Code</td>
                          <td>{dinerData?.code}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" onClick={() => setDinerData(null)}>Close</button>
                <button type="submit" className="btn btn-primary" >Submit</button>
              </div>
            </Form>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Employees;
